import { LovePoint } from "src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards.types"
import { AbonarEasyRewardsField } from "src/pages/easyrewards/components/AbonarEasyRewardsField/AbonarEasyRewardsField"
import FormSection from "../../components/FormSection/FormSection"
import FormSectionRow from "../../components/FormSectionRow/FormSectionRow"

interface PagoAbonarProps {
    lovePointsAmount: LovePoint | null
    setLovePointsAmount: (value: LovePoint | null) => void
}

// Pago cuando la renta ya está cubierta: solo se puede abonar a easyrewards
const PagoAbonar = ({ lovePointsAmount, setLovePointsAmount }: PagoAbonarProps) => (
    <FormSection title="Pago" style={{ marginBottom: 0 }}>
        <FormSectionRow>
            <div className="easyrewards-abonar__input-text">
                <AbonarEasyRewardsField setLovePointsAmount={setLovePointsAmount} lovePointsAmount={lovePointsAmount} />
            </div>
        </FormSectionRow>
    </FormSection>
)

export default PagoAbonar
